import React from "react";
import CompassSvg from "../../shared/CompassSvg";
import { Collapse, Table, TableBody, TableCell, TableRow, IconButton, Checkbox } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import clsx from "clsx";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import { getOriginLocationString, getDestinationLocationString, getTimeFromDate,getTimeFromDatebyZone } from "../../../common/helpers";
import ForTransportTableHead from "../scheduleTable/ForTransportTableHead";
import { NeedIcon, NeedListItem, AcuityNeedItem, PriorityBadge } from "../TransferIcons";
import { ClassNameMap } from "@material-ui/styles";
import Separator from "./Separator";
import YellowBox from "./YellowBox";
import { ScheduledTablePropsOld } from "../types/scheduleTypes";
interface JoinedScheduledTableProps extends ScheduledTablePropsOld {
  setCurrentTripPlannerId:any;
  vechiclecount:any;
}

const JoinedScheduledTable: React.FC<JoinedScheduledTableProps> = ({
  collapse,
  parentClasses,
  roles,
  isFullTableWidth,
  scheduleScheduledForTransportList,
  transferMode,
  history,
  checks,
  updatedTransfers,
  updateChecks,
  setCurrentTransferId,
  setCurrentBookingId,
  setShowVehicleModal,
  assignToMeClick,
  setCurrentTripPlannerId,
  vechiclecount
}) => {
  return (
    <>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 5,
            paddingTop: 5,
            paddingLeft: 0,
            paddingRight: 0,
          }}
          colSpan={0}
        >
          <Collapse in={collapse[1]} timeout="auto" unmountOnExit>
            <Box margin={0}>
              <Table size="small" aria-label="purchases" style={{ tableLayout: "fixed" }}>
                <ForTransportTableHead isFullTableWidth={isFullTableWidth} classes={parentClasses} roles={roles} />
                <TableBody>
                  {scheduleScheduledForTransportList.length > 0 ? (
                    scheduleScheduledForTransportList.map((row, index) => {
                      if (transferMode == 1 && !row.assignedToMe && roles.isSMADriver) return null;
                      if (transferMode == 1 && row.assignedVehicle != null && roles.isAdmin) return null;
                      return (
                        <React.Fragment key={index}>
                          <TableRow
                            onClick={(e) => history.push(`/transferDetails/${row.bookingId}/${row.transferId}`)}
                            hover
                            key={row.bookingId}
                            className={clsx(parentClasses.tableBody, {
                              [parentClasses.animatedUpdatedItem]: updatedTransfers.some(
                                (e) => e.TransferId === row.transferId && new Date().getTime() - e.UpdatedDate < 60000
                              ),
                            })}
                          >
                            {roles.transferCheckboxes ? (
                              row.assignedToMe ? (
                                <TableCell width="15%" className={parentClasses.tableCell} style={{paddingLeft:0}}>
                                  <Checkbox
                                    checked={checks[index]}
                                    onClick={(e: any) => e.stopPropagation()}
                                    onChange={() => updateChecks(index)}
                                    style={{ padding: 0, margin: 0, verticalAlign:"middle" }}
                                  />
                                </TableCell>
                              ) : (
                                <TableCell width="15%" className={parentClasses.tableCell}></TableCell>
                              )
                            ) : null}
                            <TableCell width="20%" className={parentClasses.tableCell}>{getTimeFromDate(row.scheduledDate)}</TableCell>
                            {isFullTableWidth && (
                              <TableCell className={parentClasses.tableCell}>
                                {row.firstName} {row.lastName}
                              </TableCell>
                            )}
                            {isFullTableWidth && (
                              <TableCell className={parentClasses.needIconCenter}>
                                {row.bookingSpecialNeeds.map((item: any) => (
                                  <NeedIcon
                                    key={row.bookingId + item.specialNeedId}
                                    iconName={item.specialNeedIconUrl.split("/")[item.specialNeedIconUrl.split("/").length - 1]}
                                  />
                                ))}
                                {row.mobility === 1 ? (
                                  <NeedListItem key="notambulant" text={"Not Ambulant"} iconUrl={"../../assets/svgs/nonambulant.svg"} />
                                ) : (
                                  <NeedListItem key="ambulant" text={"Ambulant"} iconUrl={"../../assets/svgs/ambulant.svg"} />
                                )}
                                {row.classification ? <AcuityNeedItem key="acuity" text={row.classification} /> : null}
                              </TableCell>
                            )}
                            <TableCell className={parentClasses.tableCell}>
                              <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{getOriginLocationString(row)}</div>
                            </TableCell>
                            <TableCell className={parentClasses.tableCell}>
                              <div style={{ display: "flex" }}>
                                {/* <Compass style={{ marginRight: 5, ...(row.bearingAngle ? {} : { visibility: "hidden" }) }} angle={row.bearingAngle || 0} /> */}
                                <CompassSvg
                                  style={{ marginRight: 5, ...(row.bearingAngle ? {} : { visibility: "hidden" }) }}
                                  angle={row.bearingAngle || 0}
                                />
                                <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                  {getDestinationLocationString(row)}
                                </span>
                              </div>
                            </TableCell>
                            <TableCell className={parentClasses.priorityColumn}>
                              <PriorityBadge priority={row.priority} />
                            </TableCell>
                            {(() => {
                              if (roles.isAdmin) {
                                return row.assignedVehicle ? (
                                  <TableCell className={parentClasses.tableCell}>Assigned to {row.assignedVehicle}</TableCell>
                                ) : (
                                  <TableCell className={parentClasses.tableCell}>
                                    Scheduled{" "}
                                    <span>
                                      <YellowBox
                                        onClick={(e: any) => {
                                          e.stopPropagation();
                                          setCurrentTransferId(row.transferId);
                                          setCurrentBookingId(row.bookingId);
                                          setShowVehicleModal(true);
                                          setCurrentTripPlannerId(row.tripPlannerId)
                                        }}
                                        title={roles.assignText}
                                      />
                                    </span>
                                  </TableCell>
                                );
                              } 
                              else if (roles.isCustomer && roles.canScheduleTransfer) {
                                return row.assignedVehicle ? (
                                  <TableCell className={parentClasses.tableCell}>Assigned to {row.assignedVehicle}</TableCell>
                                ) : (
                                  <TableCell className={parentClasses.tableCell}>
                                    Scheduled{" "}
                                    <span>
                                      <YellowBox
                                        onClick={(e: any) => {
                                          e.stopPropagation();
                                          setCurrentTransferId(row.transferId);
                                          setCurrentBookingId(row.bookingId);
                                          setShowVehicleModal(vechiclecount > 0 ? true:false);
                                          setCurrentTripPlannerId(row.tripPlannerId)
                                        }}
                                        title={roles.assignText}
                                      />
                                    </span>
                                  </TableCell>
                                );
                              } 
                              else if (roles.isSMAUser && roles.canScheduleTransfer) {
                                return row.assignedVehicle ? (
                                  <TableCell className={parentClasses.tableCell}>Assigned to {row.assignedVehicle}</TableCell>
                                ) : (
                                  <TableCell className={parentClasses.tableCell}>
                                    Scheduled{" "}
                                    <span>
                                      <YellowBox
                                        onClick={(e: any) => {
                                          e.stopPropagation();
                                          setCurrentTransferId(row.transferId);
                                          setCurrentBookingId(row.bookingId);
                                          setShowVehicleModal(true);
                                          setCurrentTripPlannerId(row.tripPlannerId)
                                        }}
                                        title={roles.assignText}
                                      />
                                    </span>
                                  </TableCell>
                                );
                              } 
                              else if ((roles.isSMADriver || roles.isCustomerDriver) && roles.isVehicleAllocated) {
                                return row.assignedToMe ? (
                                  <TableCell className={parentClasses.tableCell}>
                                    <span>Assigned To Me</span>
                                  </TableCell>
                                ) : row.assignedVehicle ? (
                                  <TableCell className={parentClasses.tableCell}>Assigned to {row.assignedVehicle}</TableCell>
                                ) : (
                                  <TableCell className={parentClasses.tableCell}>
                                    Scheduled{" "}
                                    <span>
                                      <YellowBox
                                        onClick={(e: any) => {
                                          e.stopPropagation();
                                          assignToMeClick(row.bookingId, row.transferId);
                                        }}
                                        title={roles.assignText}
                                      />
                                    </span>
                                  </TableCell>
                                );
                              } else {
                                return row.assignedVehicle ? (
                                  <TableCell className={parentClasses.tableCell}>Assigned to {row.assignedVehicle}</TableCell>
                                ) : (
                                  <TableCell className={parentClasses.tableCell}>Scheduled</TableCell>
                                );
                              }
                            })()}
                            <TableCell style={{ width: 20 }} align="right">
                              <IconButton aria-label="expand row" size="small">
                                <ArrowForwardIosIcon style={{ fontSize: 20 }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          <Separator />
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={roles.transferCheckboxes ? 9 : 8}>
                        No Records Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
export default JoinedScheduledTable;
